export { default, SvgIconProps } from '@material-ui/core/SvgIcon';
